import type { FC } from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const CancerScreeningScreenedBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-success text-white">
      <Check className="size-3" />
      {t('component:badge.cancerScreeningScreened')}
    </Badge>
  );
};
